import { PostMappingTypeEnum, } from '@tribeplatform/gql-client/types';
export const getPostIdFromPath = path => {
    const parts = path.match(/[a-zA-Z0-9]+$/);
    if (!(parts === null || parts === void 0 ? void 0 : parts.length))
        return null;
    return parts[0];
};
export const getPostFields = (post) => {
    var _a;
    return (_a = post === null || post === void 0 ? void 0 : post.mappingFields) === null || _a === void 0 ? void 0 : _a.reduce((acc, curr) => {
        try {
            return {
                ...acc,
                [curr.key]: { ...curr, value: JSON.parse((curr === null || curr === void 0 ? void 0 : curr.value) || '""') },
            };
        }
        catch (e) {
            return {
                ...acc,
                [curr.key]: curr,
            };
        }
    }, {});
};
export const getPostFieldValue = (post, field) => {
    var _a, _b, _c, _d;
    if (!post)
        return '';
    const value = (_d = (_c = (_b = (_a = post === null || post === void 0 ? void 0 : post.mappingFields) === null || _a === void 0 ? void 0 : _a.find) === null || _b === void 0 ? void 0 : _b.call(_a, f => (f === null || f === void 0 ? void 0 : f.key) === field)) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '""';
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return value;
    }
};
export const getMappingFields = ({ title, content, postTypeName, }) => {
    let mappingFields;
    switch (postTypeName === null || postTypeName === void 0 ? void 0 : postTypeName.toLowerCase()) {
        case 'discussion':
            mappingFields = generateMappingFieldForDiscussion({
                title,
                content,
            });
            break;
        case 'comment':
            mappingFields = generateMappingFieldForComment({
                content,
            });
            break;
        case 'question':
            mappingFields = generateMappingFieldForQuestion({
                title,
                content,
            });
            break;
        case 'answer':
            mappingFields = generateMappingFieldForAnswer({
                content,
            });
            break;
        default:
            mappingFields = [];
            break;
    }
    return mappingFields;
};
export const generateMappingFieldForDiscussion = ({ title, content, }) => {
    const output = [];
    if (typeof title === 'string') {
        output.push({
            key: 'title',
            type: PostMappingTypeEnum.text,
            value: JSON.stringify(title),
        });
    }
    if (typeof content === 'string') {
        output.push({
            key: 'content',
            type: PostMappingTypeEnum.html,
            value: JSON.stringify(content),
        });
    }
    return output;
};
export const generateMappingFieldForComment = ({ content, }) => {
    const output = [];
    if (typeof content === 'string') {
        output.push({
            key: 'content',
            type: PostMappingTypeEnum.html,
            value: JSON.stringify(content),
        });
    }
    return output;
};
export const generateMappingFieldForQuestion = ({ title, content, }) => {
    const output = [];
    if (typeof title === 'string') {
        output.push({
            key: 'question',
            type: PostMappingTypeEnum.text,
            value: JSON.stringify(title),
        });
        output.push({
            key: 'title',
            type: PostMappingTypeEnum.text,
            value: JSON.stringify(title),
        });
    }
    if (typeof content === 'string') {
        output.push({
            key: 'description',
            type: PostMappingTypeEnum.html,
            value: JSON.stringify(content),
        });
        output.push({
            key: 'content',
            type: PostMappingTypeEnum.html,
            value: JSON.stringify(content),
        });
    }
    return output;
};
export const generateMappingFieldForAnswer = ({ content, }) => {
    const output = [];
    if (typeof content === 'string') {
        output.push({
            key: 'answer',
            type: PostMappingTypeEnum.html,
            value: JSON.stringify(content),
        });
        output.push({
            key: 'content',
            type: PostMappingTypeEnum.html,
            value: JSON.stringify(content),
        });
    }
    return output;
};
export const getParentPostId = (post) => {
    var _a, _b, _c;
    if (Array.isArray(post === null || post === void 0 ? void 0 : post.repliedToIds) || (post === null || post === void 0 ? void 0 : post.repliedToId)) {
        // Usually, the last index should be the root post
        const lastIndexPost = (_a = post === null || post === void 0 ? void 0 : post.repliedToIds) === null || _a === void 0 ? void 0 : _a[((_b = post === null || post === void 0 ? void 0 : post.repliedToIds) === null || _b === void 0 ? void 0 : _b.length) - 1];
        const parentPostId = lastIndexPost || (post === null || post === void 0 ? void 0 : post.repliedToId) || ((_c = post === null || post === void 0 ? void 0 : post.repliedToIds) === null || _c === void 0 ? void 0 : _c[0]);
        return parentPostId;
    }
};
//# sourceMappingURL=post.js.map